import { create } from "zustand";
import {
  fetchSharedWithMeSpaces,
  type SharedSpace,
} from "@/lib/api/sharedWithMe";

/// The cross-org granted-space set (D32). Identity-scoped, so unlike the org
/// context nothing here changes when the switcher does. Models come from the
/// existing overview poll (`via === "external"` rows); this store carries the
/// half the models list cannot: the spaces themselves, with their owning-org
/// labels.
interface SharedWithMeState {
  spaces: SharedSpace[];
  /// `loading` until the first answer arrives. A failed fetch must never read
  /// as "nothing is shared" — that would hide the nav item and state the
  /// opposite of the truth — so it lands on `error` while `spaces` keeps
  /// whatever was already known, and a failure AFTER a good load stays
  /// `ready` rather than downgrading what is on screen.
  status: "loading" | "ready" | "error";
  refresh: () => Promise<void>;
}

export const useSharedWithMeStore = create<SharedWithMeState>((set, get) => ({
  spaces: [],
  status: "loading",
  refresh: async () => {
    const spaces = await fetchSharedWithMeSpaces();
    if (spaces === null) {
      if (get().status !== "ready") set({ status: "error" });
      return;
    }
    set({ spaces, status: "ready" });
  },
}));
